<app-template>
    <app-breadcrumb>
        <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
        <li class="breadcrumb-item">Orders</li>
        <li class="breadcrumb-item active">Invoices</li>
    </app-breadcrumb>

    <app-main-heading>All Invoices</app-main-heading>

    <div class="row d-flex">
        <div class="col-5 me-auto">
            <mat-form-field class="me-3 w-100">
                <mat-label>Search</mat-label>
                <input matInput type="text" [(ngModel)]="value" (keyup)="applyFilter($event)">
                <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-auto">
            <!-- <button mat-raised-button>Add</button> -->
            <button disabled mat-raised-button>Add</button>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">
                <ng-container matColumnDef="index">
                    <th mat-header-cell *matHeaderCellDef> No. </th>
                    <td mat-cell *matCellDef="let element, let i = index"> {{i+1}} </td>
                </ng-container>

                <ng-container matColumnDef="invoiceDate">
                    <th mat-header-cell *matHeaderCellDef> Invoice Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.invoiceDate}} </td>
                </ng-container>

                <ng-container matColumnDef="invoiceAccount">
                    <th mat-header-cell *matHeaderCellDef> Invoice Account </th>
                    <td mat-cell *matCellDef="let element"> {{element.invoiceAccount}} </td>
                </ng-container>

                <ng-container matColumnDef="invoiceStatus">
                    <th mat-header-cell *matHeaderCellDef> Invoice Status </th>
                    <td mat-cell *matCellDef="let element"> {{element.invoiceStatus}} </td>
                </ng-container>

                <ng-container matColumnDef="paidAmount">
                    <th mat-header-cell *matHeaderCellDef> Paid Amount </th>
                    <td mat-cell *matCellDef="let element"> {{element.paidAmount}} </td>
                </ng-container>

                <ng-container matColumnDef="orderNo">
                    <th mat-header-cell *matHeaderCellDef> Order No. </th>
                    <td mat-cell *matCellDef="let element"> {{element.orderNo}} </td>
                </ng-container>

                <ng-container matColumnDef="orderDate">
                    <th mat-header-cell *matHeaderCellDef> Order Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.orderDate}} </td>
                </ng-container>

                <ng-container matColumnDef="orderStatus">
                    <th mat-header-cell *matHeaderCellDef> Order Status </th>
                    <td mat-cell *matCellDef="let element"> {{element.orderStatus}} </td>
                </ng-container>

                <ng-container matColumnDef="contactName">
                    <th mat-header-cell *matHeaderCellDef> Contact Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.contactName}} </td>
                </ng-container>

                <ng-container matColumnDef="contactAddress">
                    <th mat-header-cell *matHeaderCellDef> Contact Address </th>
                    <td mat-cell *matCellDef="let element"> {{element.contactAddress}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="12">No records to display.</td>
                </tr>

            </table>
            <mat-paginator class="mat-elevation-z2" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
                aria-label="Select no. of rows per page">
            </mat-paginator>
        </div>
    </div>
</app-template>